import React, { ComponentPropsWithoutRef, ReactNode } from 'react';
import { Button } from 'antd';
import 'baseComponents/ButtonComponent/buttonComponent.scss';

interface ButtonComponentProps extends ComponentPropsWithoutRef<typeof Button> {
  appereance: 'primary' | 'secondary' | 'warning';
  size: 'small' | 'middle' | 'large';
  label: ReactNode;
  type?: any;
  htmlType?: 'submit' | 'reset' | 'button';
  uppercase?: boolean;
  fullWidth?: boolean;
  onClick?: (value?: any) => void;
  className?: string;
}

export const ButtonComponent: React.FC<ButtonComponentProps> = ({
  appereance,
  size,
  label,
  uppercase,
  fullWidth,
  onClick,
  type,
  htmlType = 'button',
  className,
  ...rest
}) => {
  return (
    <Button
      className={`button-component ${
        fullWidth ? 'full-width' : ''
      } ${appereance} ${size} ${uppercase ? 'uppercase' : ''} ${className}`}
      size={size}
      type={appereance === 'primary' ? 'primary' : undefined}
      onClick={onClick}
      htmlType={htmlType}
      {...rest}
    >
      {label}
    </Button>
  );
};
